<div *ngIf="RESULT_VALUES" class="clearance-select-button">
  <div *ngFor="let resultValue of RESULT_VALUES">
    <label>
      <input
        type="radio"
        [name]="name"
        [checked]="resultValue.value === value"
        (click)="setValue(resultValue.value)"
        [value]="resultValue.value"
        [disabled]="disabled"
      />
      <div
        [ngClass]="getResultSelectButtonStyle(resultValue.value, disabled)"
        class="clearance-select-button__item">
        {{ resultValue.label | uppercase }}
      </div>
    </label>
  </div>
</div>
